import React, { useState, useEffect } from 'react';
import { Layout as AntLayout, Menu, Dropdown, Avatar, Space, Button } from 'antd';
import {
  DashboardOutlined,
  MobileOutlined,
  SecurityScanOutlined,
  FolderOutlined,
  AppstoreOutlined,
  UserOutlined,
  LogoutOutlined,
  LockOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ChangePassword from './ChangePassword';

const { Header, Sider, Content, Footer } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, refreshUser } = useAuth();
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);

  // 检测用户类型，如果为空则尝试刷新
  useEffect(() => {
    if (user && !user.userType) {
      console.log('Detected missing userType, refreshing user info...');
      refreshUser().then(success => {
        if (success) {
          console.log('User info refreshed successfully');
        } else {
          console.log('Failed to refresh user info');
        }
      });
    }
  }, [user, refreshUser]);

  const menuItems = (
    user?.userType === 'device_editor'
      ? [
          {
            key: '/devices',
            icon: <MobileOutlined />,
            label: '设备列表',
          },
        ]
      : [
          {
            key: '/',
            icon: <DashboardOutlined />,
            label: '仪表盘',
          },
          {
            key: '/versions',
            icon: <AppstoreOutlined />,
            label: '版本列表',
          },
          {
            key: '/policies',
            icon: <SecurityScanOutlined />,
            label: '管控措施列表',
          },
          {
            key: '/categories',
            icon: <FolderOutlined />,
            label: '目录列表',
          },
          {
            key: '/devices',
            icon: <MobileOutlined />,
            label: '设备列表',
          },
          // 只有超级管理员才能看到用户管理
          ...(user?.userType === 'super_admin' ? [{
            key: '/users',
            icon: <UserOutlined />,
            label: '用户管理',
          }] : []),
          // 只有超级管理员才能看到重置数据
          ...(user?.userType === 'super_admin' ? [{
            key: '/reset-data',
            icon: <DeleteOutlined />,
            label: '重置数据',
            danger: true,
          }] : []),
        ]
  );

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  const handleLogout = () => {
    logout();
  };

  const userMenuItems = [
    {
      key: 'change-password',
      icon: <LockOutlined />,
      label: '修改密码',
      onClick: () => setChangePasswordVisible(true),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  return (
    <AntLayout className="ant-layout">
      <Header className="ant-layout-header" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 24px'
      }}>
        <div className="logo" style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
          📱 易管移动设备管控平台
        </div>
        <Space>
          <span style={{ color: 'white' }}>欢迎，{user?.username} ({user?.userType || 'unknown'})</span>
          <Dropdown
            menu={{ items: userMenuItems }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Button
              type="text"
              style={{ color: 'white' }}
              icon={<Avatar size="small" icon={<UserOutlined />} />}
            >
              {user?.username}
            </Button>
          </Dropdown>
        </Space>
      </Header>
      <AntLayout>
        <Sider width={200} style={{ background: '#fff' }}>
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: '100%', borderRight: 0 }}
            items={menuItems}
            onClick={handleMenuClick}
          />
        </Sider>
        <AntLayout style={{ padding: '0' }}>
          <Content className="ant-layout-content">
            {children}
          </Content>
          <Footer style={{
            textAlign: 'center',
            background: '#f0f2f5',
            borderTop: '1px solid #d9d9d9',
            padding: '16px 24px'
          }}>
            <div>
              V2508112 © 2013-2025{' '}
              <a
                href="https://baibaomen.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1890ff', textDecoration: 'none' }}
              >
                长沙百宝门信息科技有限公司
              </a>
            </div>
            <div style={{ marginTop: '4px' }}>
              湘ICP备14000611号-1
            </div>
          </Footer>
        </AntLayout>
      </AntLayout>

      {/* 修改密码弹窗 */}
      <ChangePassword
        visible={changePasswordVisible}
        onCancel={() => setChangePasswordVisible(false)}
      />
    </AntLayout>
  );
};

export default Layout;
